import { Grid, Button } from '@mui/material';
import { AddDealInput } from 'api';
import { useState, useEffect, useContext } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TXT_ADD } from '../../../../../shared/translations';
import AddIcon from '@mui/icons-material/Add';
import { DealWizardSupplier } from './DealWizardSupplier';
import { DealWizardContext } from './DealWizard';

export const DealWizardSuppliers = () => {
  const { control } = useFormContext<AddDealInput>();
  const { isDisabled } = useContext(DealWizardContext);
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'suppliers'
  });
  const [tempId, setTempId] = useState(-1);

  const handleAdd = () => {
    append({
      id: `${tempId}`,
      canDelete: true,
      quantity: undefined,
      incoTerm: undefined
    });
    setTempId(tempId - 1);
  };

  useEffect(() => {
    document.getElementById('frm-deal-wizard')?.scrollIntoView(false);
  }, [tempId]);

  return (
    <Grid container spacing={1}>
      {fields.map((field, index) => {
        return (
          <Grid item xs={12} key={`suppliers-${field.id}`}>
            <DealWizardSupplier handleRemove={remove} index={index} />
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd} disabled={isDisabled}>
          {t(TXT_ADD)}
        </Button>
      </Grid>
    </Grid>
  );
};
